import { useEffect, useRef, useState } from "react";
import {
  getArrayDocDataByID,
  getDocDataById,
  getLocalStringFromFlutter,
  listenCollection,
  queryCollection,
  getFlutterTime,
  getRefFromId,
} from "../models/DataFunctions";
import { Timestamp } from "firebase/firestore";
import PrimaryButton from "../buttons/PrimaryButton";
import SecondaryButton from "../buttons/SecondaryButton";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { EasySwitch } from "../textfields/EasySwitch";
import CheckBoxGrey from "../textfields/CheckBoxGrey";
import { all } from "axios";
import { intToHexColor } from "../models/OrgFunctions";
import updateDocApi from "../api/database/updateDocApi";
import SmallSpinner from "../loading/SmallSpinner";
import deleteDocApi from "../api/database/deleteDocApi";
import Modal1 from "../modals/Modal1";
import AddTask from "../folder_modals/AddTask";
import TextField2T from "../textfields/TextField2T";
import MLTFGPT3 from "../textfields/MLTFGPT3";
import Icon1 from "../icons/Icon";

const TaskDisplay = ({
  userData,
  orgData,
  visible,
  prefix,
  handleClickVariant,
  navigateWorkspace,
  setTaskNumberNotif,
}) => {
  const [tasks, setTasks] = useState([]);
  const [task_selected, setTaskSelected] = useState(null);
  const unsubscribeRef_todo = useRef(null);
  const unsubscribeRef_todo_created = useRef(null);
  const [tasksAssigned, setTasksAssigned] = useState([]);
  const [tasksCreated, setTasksCreated] = useState([]);
  const [users, setUsers] = useState([]);
  const [mine, setMine] = useState(true);
  const [this_folder, setThisFolder] = useState(false);
  const [newTaskOpen, setNewTaskOpen] = useState(false);
  const [folder, setFolder] = useState(null);
  const [showHistory, setShowHistory] = useState(false);
  const [historyStartDate, setHistoryStartDate] = useState("");
  const [historyEndDate, setHistoryEndDate] = useState("");
  const [selectedTasks, setSelectedTasks] = useState([]);
  const handleFetchHistoryTasks = async () => {
    if (!historyStartDate || !historyEndDate) {
      handleClickVariant("Veuillez sélectionner une période", "error");
      return;
    }

    const startDate = new Date(historyStartDate);
    const endDate = new Date(historyEndDate);
    endDate.setHours(23, 59, 59, 999); // End of day

    let filters_assigned = [
      {
        field: "creation_date",
        operator: ">=",
        value: Timestamp.fromDate(startDate),
      },
      {
        field: "creation_date",
        operator: "<=",
        value: Timestamp.fromDate(endDate),
      },
      {
        field: "users_id",
        operator: "array-contains",
        value: userData.id,
      },
    ];

    let history_tasks_assigned = await queryCollection(
      "task",
      filters_assigned,
      100,
      "creation_date",
      "desc",
    );

    let filters_created = [
      {
        field: "creation_date",
        operator: ">=",
        value: Timestamp.fromDate(startDate),
      },
      {
        field: "creation_date",
        operator: "<=",
        value: Timestamp.fromDate(endDate),
      },
      {
        field: "author_user_id",
        operator: "==",
        value: userData.id,
      },
    ];

    let history_tasks_created = await queryCollection(
      "task",
      filters_created,
      100,
      "creation_date",
      "desc",
    );

    // Merge and deduplicate
    const tasksMap = new Map();
    [...history_tasks_assigned, ...history_tasks_created].forEach((task) => {
      tasksMap.set(task.id, task);
    });
    const history_tasks = Array.from(tasksMap.values());

    setTasks(history_tasks);
  };

  const handleFetchData = async () => {
    let users =
      (await getArrayDocDataByID("user", orgData.users_id || [])) || [];
    setUsers(users);
    if (mine) {
      // Show tasks assigned to user (including done tasks)
      let filters_assigned = [
        {
          field: "users_id",
          operator: "array-contains",
          value: userData.id,
        },
      ];
      let tasks_assigned = await queryCollection(
        "task",
        filters_assigned,
        100,
        "creation_date",
        "desc",
      );

      // Show tasks created by user (including done tasks)
      let filters_created = [
        {
          field: "author_user_id",
          operator: "==",
          value: userData.id,
        },
      ];
      let tasks_created = await queryCollection(
        "task",
        filters_created,
        100,
        "creation_date",
        "desc",
      );

      // Merge and deduplicate tasks
      const tasksMap = new Map();
      [...tasks_assigned, ...tasks_created].forEach((task) => {
        tasksMap.set(task.id, task);
      });
      const tasks = Array.from(tasksMap.values());

      setTasks(tasks);
      // Count unseen tasks (where user is not in seen_by AND user is assigned or author) - including done tasks
      const unseenCount = tasks.filter(
        (t) =>
          !t.seen_by?.includes(userData.id) &&
          (t.users_id?.includes(userData.id) ||
            t.author_user_id === userData.id),
      ).length;
      setTaskNumberNotif(unseenCount);
    } else {
      // Show user's pending tasks (assigned) and completed tasks from last 3 days
      let filters_pending_assigned = [
        {
          field: "done",
          operator: "==",
          value: false,
        },
        {
          field: "users_id",
          operator: "array-contains",
          value: userData.id,
        },
      ];
      let pending_tasks_assigned = await queryCollection(
        "task",
        filters_pending_assigned,
        100,
        "creation_date",
        "desc",
      );

      // Show user's pending tasks (created by user)
      let filters_pending_created = [
        {
          field: "done",
          operator: "==",
          value: false,
        },
        {
          field: "author_user_id",
          operator: "==",
          value: userData.id,
        },
      ];
      let pending_tasks_created = await queryCollection(
        "task",
        filters_pending_created,
        100,
        "creation_date",
        "desc",
      );

      const threeDaysAgo = new Date();
      threeDaysAgo.setDate(threeDaysAgo.getDate() - 3);
      threeDaysAgo.setHours(0, 0, 0, 0);

      let filters_done_assigned = [
        {
          field: "done",
          operator: "==",
          value: true,
        },
        {
          field: "creation_date",
          operator: ">=",
          value: Timestamp.fromDate(threeDaysAgo),
        },
        {
          field: "users_id",
          operator: "array-contains",
          value: userData.id,
        },
      ];
      let done_tasks_assigned = await queryCollection(
        "task",
        filters_done_assigned,
        100,
        "creation_date",
        "desc",
      );

      let filters_done_created = [
        {
          field: "done",
          operator: "==",
          value: true,
        },
        {
          field: "creation_date",
          operator: ">=",
          value: Timestamp.fromDate(threeDaysAgo),
        },
        {
          field: "author_user_id",
          operator: "==",
          value: userData.id,
        },
      ];
      let done_tasks_created = await queryCollection(
        "task",
        filters_done_created,
        100,
        "creation_date",
        "desc",
      );

      console.log("Fetched done tasks:", [
        ...done_tasks_assigned,
        ...done_tasks_created,
      ]);

      // Merge and deduplicate all tasks
      const tasksMap = new Map();
      [
        ...pending_tasks_assigned,
        ...pending_tasks_created,
        ...done_tasks_assigned,
        ...done_tasks_created,
      ].forEach((task) => {
        tasksMap.set(task.id, task);
      });
      const allTasks = Array.from(tasksMap.values());

      setTasks(allTasks);
      // Count unseen tasks (including done tasks)
      const unseenCount = allTasks.filter(
        (t) =>
          !t.seen_by?.includes(userData.id) &&
          (t.users_id?.includes(userData.id) ||
            t.author_user_id === userData.id),
      ).length;
      setTaskNumberNotif(unseenCount);
    }
  };

  const onGoToFolder = () => {
    if (task_selected?.folder_ref) {
      navigateWorkspace("/folder/" + task_selected.folder_ref.id + "?hello");
      window.location.reload();
    }
  };

  const handleDeleteTask = async () => {
    if (task_selected) {
      await deleteDocApi(task_selected.ref, prefix);
      handleClickVariant("Tâche supprimée", "success");
      setTaskSelected(null);
      handleFetchData();
    }
  };

  const handleFetchPageFolder = async () => {
    // extract folder id from route if route is /folder/:id
    let path = window.location.pathname;

    if (path.includes("/folder/")) {
      let end_term = path.split("/folder/")[1];
      let folder_id = end_term.split("/")[0];
      if (folder_id) {
        let folder_data = await getDocDataById("folder", folder_id);
        setFolder(folder_data);
      } else {
        setFolder(null);
      }
    } else {
      setFolder(null);
    }
  };

  const handleSelectTask = async (task) => {
    // Update seen_by field to include current user if not already present
    let current_seen_by = task.seen_by || [];
    if (!current_seen_by.includes(userData.id)) {
      current_seen_by.push(userData.id);
      await updateDocApi(task.ref, { seen_by: current_seen_by }, prefix);
    }
    // Set the task as selected with updated seen_by
    setTaskSelected({ ...task, seen_by: current_seen_by });
  };

  useEffect(() => {
    handleFetchPageFolder();
  }, [window.location.pathname]);

  // Merge and deduplicate tasks whenever tasksAssigned or tasksCreated change
  useEffect(() => {
    if (mine) {
      const tasksMap = new Map();
      [...tasksAssigned, ...tasksCreated].forEach((task) => {
        tasksMap.set(task.id, task);
      });
      const mergedTasks = Array.from(tasksMap.values());
      setTasks(mergedTasks);

      // Count unseen tasks (including done tasks)
      const unseenCount = mergedTasks.filter(
        (t) =>
          !t.seen_by?.includes(userData.id) &&
          (t.users_id?.includes(userData.id) ||
            t.author_user_id === userData.id),
      ).length;
      setTaskNumberNotif(unseenCount);
    }
  }, [tasksAssigned, tasksCreated, mine, userData?.id]);

  const [loadingUsersDone, setLoadingUsersDone] = useState(null);

  const handleDeleteTasks = async (taskIds) => {
    try {
      await Promise.all(
        taskIds.map((id) => deleteDocApi(getRefFromId("task", id), prefix)),
      );
      handleClickVariant("Tâches supprimées", "success");
      if (taskIds.includes(task_selected?.id)) {
        setTaskSelected(null);
      }
      handleFetchData();
    } catch (error) {
      console.error("Error deleting tasks:", error);
      handleClickVariant("Erreur lors de la suppression des tâches", "error");
    }
  };

  const handleSetUsersDone = async (user_id) => {
    setLoadingUsersDone(user_id);
    if (task_selected) {
      let new_users_done = task_selected.users_done_id || [];
      if (new_users_done.includes(user_id)) {
        new_users_done = new_users_done.filter((u) => u !== user_id);
      } else {
        new_users_done.push(user_id);
      }
      const isTaskDone =
        new_users_done.length === task_selected.users_id.length;

      // Prepare update object
      const updateData = {
        users_done_id: new_users_done,
        done: isTaskDone,
      };

      // Add finish_date when task becomes done, remove it when undone
      if (isTaskDone) {
        updateData.finish_date = getFlutterTime();
        // Reset seen_by to only the user who marked it as done when task is validated
        // This will increment the counter for all other participants (author + members)
        updateData.seen_by = [userData.id];
      } else {
        updateData.finish_date = null;
      }

      await updateDocApi(task_selected.ref, updateData, prefix);
      setTaskSelected({
        ...task_selected,
        users_done_id: new_users_done,
        done: isTaskDone,
        finish_date: updateData.finish_date,
        seen_by: updateData.seen_by || task_selected.seen_by,
      });

      handleFetchData();
    }
    setLoadingUsersDone(null);
  };
  // Initial data fetch when component becomes visible
  useEffect(() => {
    if (userData?.id) {
      console.log("Fetching task data...");
      handleFetchData();
    }
  }, [userData?.id, orgData?.id]);

  useEffect(() => {
    if (!userData?.id) {
      console.log("Unsubscribing from task listeners...");
      return;
    }

    if (mine) {
      // Listener 1: Tasks assigned to user (including done tasks)
      const filters_assigned = [
        { field: "users_id", operator: "array-contains", value: userData.id },
      ];

      listenCollection(
        "task",
        filters_assigned,
        100,
        "creation_date",
        "desc",
        (newTasks) => {
          setTasksAssigned(newTasks);
        },
        unsubscribeRef_todo,
        (error) => {
          console.error("Error in assigned tasks listener:", error);
        },
      );

      // Listener 2: Tasks created by user (including done tasks)
      const filters_created = [
        { field: "author_user_id", operator: "==", value: userData.id },
      ];

      listenCollection(
        "task",
        filters_created,
        100,
        "creation_date",
        "desc",
        (newTasks) => {
          setTasksCreated(newTasks);
        },
        unsubscribeRef_todo_created,
        (error) => {
          console.error("Error in created tasks listener:", error);
        },
      );
    } else {
      // Refresh data when switching to "Toutes" mode
      // We use handleFetchData instead of listeners for the combined view
      handleFetchData();

      // Clean up any existing listeners
      if (unsubscribeRef_todo.current) {
        unsubscribeRef_todo.current();
        unsubscribeRef_todo.current = null;
      }
      if (unsubscribeRef_todo_created.current) {
        unsubscribeRef_todo_created.current();
        unsubscribeRef_todo_created.current = null;
      }
    }

    return () => {
      if (unsubscribeRef_todo.current) {
        unsubscribeRef_todo.current();
        unsubscribeRef_todo.current = null;
      }
      if (unsubscribeRef_todo_created.current) {
        unsubscribeRef_todo_created.current();
        unsubscribeRef_todo_created.current = null;
      }
    };
  }, [userData?.id, mine, orgData?.id]);

  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      if (unsubscribeRef_todo.current) {
        unsubscribeRef_todo.current();
        unsubscribeRef_todo.current = null;
      }
      if (unsubscribeRef_todo_created.current) {
        unsubscribeRef_todo_created.current();
        unsubscribeRef_todo_created.current = null;
      }
    };
  }, []);

  return (
    <div
      className={`absolute right-4 transition-all duration-300 ease-in-out ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-full pointer-events-none"
      }`}
      style={{
        bottom: "82px",
        zIndex: 200000,
        maxHeight: "80vh",
      }}
    >
      <Modal1 isOpen={newTaskOpen} onClose={() => setNewTaskOpen(false)}>
        <AddTask
          folder={folder}
          orgData={orgData}
          userData={userData}
          onClose={() => setNewTaskOpen(false)}
          onUpdate={() => handleFetchData()}
        ></AddTask>
      </Modal1>

      <div
        className="bg-white overflow-hidden flex flex-col rounded-2xl p-4 shadow-xl shadow-shadow_10 h-full max-h-c500 min-h-c500 w-c400 mt-4"
        style={{
          boxShadow: "0px 4px 40px rgba(0, 0, 0, 0.2)",
        }}
      >
        <>
          {task_selected ? (
            <>
              <TaskBlockSelected
                key={task_selected.id}
                task={task_selected}
                onDelete={handleDeleteTask}
                onClick={() => setTaskSelected(null)}
                onGoToFolder={onGoToFolder}
                all_users={users}
                handleSetUsersDone={handleSetUsersDone}
                loadingUsersDone={loadingUsersDone}
                userData={userData}
                orgData={orgData}
                prefix={prefix}
                onUpdate={handleFetchData}
              />
            </>
          ) : (
            <>
              <div className="flex flex-col gap-2 mb-4">
                <div className="flex flex-row justify-between items-center">
                  <div className="text-h2 font-semibold ">Tâches en cours</div>
                  <div className="flex flex-col items-end w-c100 gap-1">
                    <div
                      className={`
                        ${folder ? "justify-between w-full" : ""}
                        flex flex-row  gap-2`}
                    >
                      <div className="text-h5 text-gray-500  text-right">
                        Toutes
                      </div>
                      <EasySwitch
                        checked={!mine}
                        onChange={() => {
                          setMine(!mine);
                          setShowHistory(false);
                        }}
                        label={mine ? "Mes tâches" : "Toutes les tâches"}
                      />
                    </div>
                    {folder && (
                      <div className="flex flex-row justify-between w-full gap-2">
                        <div className="text-h5 text-gray-500  text-right">
                          Ce dossier
                        </div>
                        <EasySwitch
                          checked={this_folder}
                          onChange={() => setThisFolder(!this_folder)}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {/* Historique Button */}
                <div className="flex flex-col gap-2 items-end">
                  <SecondaryButton
                    onClick={() => setShowHistory(!showHistory)}
                    className="w-fit"
                  >
                    {showHistory ? "Masquer l'historique" : "Voir l'historique"}
                  </SecondaryButton>
                  {selectedTasks.length > 0 && (
                    <PrimaryButton
                      onClick={() => {
                        handleDeleteTasks(selectedTasks);
                        setSelectedTasks([]);
                      }}
                      className="w-fit"
                    >
                      Supprimer les tâches sélectionnées
                    </PrimaryButton>
                  )}
                </div>

                {/* History Date Range Picker */}
                {showHistory && (
                  <div className="flex flex-col gap-2 p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <div className="text-h3 font-semibold text-gray-700">
                      Période de l'historique
                    </div>
                    <div className="flex flex-col gap-2">
                      <TextField2T
                        type="date"
                        label="Date de début"
                        value={historyStartDate}
                        onChange={(e) => setHistoryStartDate(e.target.value)}
                      />
                      <TextField2T
                        type="date"
                        label="Date de fin"
                        value={historyEndDate}
                        onChange={(e) => setHistoryEndDate(e.target.value)}
                      />
                      <PrimaryButton
                        onClick={handleFetchHistoryTasks}
                        disabled={!historyStartDate || !historyEndDate}
                      >
                        Rechercher
                      </PrimaryButton>
                    </div>
                  </div>
                )}
              </div>
              <div className="flex flex-col gap-0 overflow-y-auto flex-1 min-h-0 mt-2 pr-2">
                {tasks.length === 0 && (
                  <>
                    <div className="text-h3  text-gray-600">
                      Aucune tâche en cours
                    </div>{" "}
                    <div className="text-h3  text-gray-400">
                      Créez une tâche depuis la page dossier {"-> "}Actions{" "}
                      {"-> "} Ajouter une tâche
                    </div>
                  </>
                )}
                {tasks
                  .sort((a, b) => {
                    // Sort by done status first (not done first), then by creation_date descending
                    if (a.done === b.done) {
                      return b.creation_date.seconds - a.creation_date.seconds;
                    }
                    return a.done ? 1 : -1;
                  })
                  .filter((task) => {
                    if (this_folder && folder) {
                      return (
                        task.folder_ref && task.folder_ref.id === folder.id
                      );
                    }
                    return true;
                  })
                  .map((task, index) => (
                    <div key={index}>
                      <TaskBlock
                        key={task.id}
                        task={task}
                        onClick={() => handleSelectTask(task)}
                        all_users={users}
                        is_mine={task.users_id?.includes(userData.id)}
                        user_id={userData.id}
                        setSelectedTasks={setSelectedTasks}
                        selectedTasks={selectedTasks}
                      />
                    </div>
                  ))}
              </div>
              <div className="pt-2 pb-1 flex justify-end shrink-0">
                <PrimaryButton onClick={() => setNewTaskOpen(true)}>
                  Ajouter une tâche
                </PrimaryButton>
              </div>
            </>
          )}
        </>
      </div>
    </div>
  );
};

export default TaskDisplay;

export const TaskBlock = ({
  task,
  onClick,
  all_users,
  is_mine,
  user_id,
  selectedTasks,
  setSelectedTasks,
}) => {
  const is_unread = !task.seen_by?.includes(user_id);
  const comments_count = task.comments?.length || 0;

  return (
    <div
      onClick={onClick}
      className={`
        ${
          task.done
            ? "border-green-200 border-0 bg-gray-100"
            : is_mine
              ? "bg-white border-blue-400 shadow-md shadow-blue-100"
              : "bg-white border-indigo-200 shadow-md shadow-indigo-100"
        }
        flex relative cursor-pointer mb-2 hover:shadow-md flex-col gap-1 border-l-3 rounded-lg p-3 `}
    >
      <div className={`text-h3 ${is_unread ? "font-bold" : ""}`}>
        {task.title}
      </div>
      <div
        className={`text-h3 text-gray-500 ${is_unread ? "font-semibold" : ""}`}
      >
        {task.content?.substring(0, 50) +
          (task.content?.length > 50 ? "..." : "")}
      </div>
      <div className="text-h5 text-gray-400  flex flex-row justify-between items-center">
        <div className="flex flex-row items-center gap-2">
          <span>
            {dateTextFromFlutterDate(task.creation_date)}
            {all_users?.find((u) => u.id === task.author_user_id) ? (
              <span>
                {" "}
                par{" "}
                {all_users?.find((u) => u.id === task.author_user_id)
                  ?.display_name || "Utilisateur supprimé"}{" "}
              </span>
            ) : null}
          </span>
          {comments_count > 0 && (
            <div className="flex flex-row items-center gap-1 text-blue-500">
              <Icon1 icon_name="message" size="14px" fill="#3b82f6" />
              <span className="text-h6">{comments_count}</span>
            </div>
          )}
        </div>
        <div className="flex flex-col h-full  ">
          <div className="flex flex-row  gap-0 mt-auto">
            {all_users
              ?.filter((u) => task.users_id.includes(u.id))
              ?.map((u, index) => (
                <div key={index}>
                  <img
                    className="w-6 h-6 rounded-full inline"
                    src={
                      u?.photo ||
                      "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg?20200418092106"
                    }
                  />
                </div>
              ))}
          </div>
        </div>{" "}
      </div>{" "}
      <div className="absolute top-2 right-2">
        <CheckBoxGrey
          checked={selectedTasks?.includes(task.id)}
          onChange={(checked) => {
            if (selectedTasks?.includes(task.id)) {
              setSelectedTasks(selectedTasks.filter((id) => id !== task.id));
            } else {
              setSelectedTasks([...(selectedTasks || []), task.id]);
            }
          }}
        ></CheckBoxGrey>
      </div>
    </div>
  );
};

export const TaskBlockSelected = ({
  task,
  onClick,
  loadingUsersDone,
  onGoToFolder,
  all_users,
  onDelete,
  handleSetUsersDone,
  userData,
  prefix,
  onUpdate,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState(task.title);
  const [editedContent, setEditedContent] = useState(task.content);
  const [comments, setComments] = useState(task.comments || []);
  const [newComment, setNewComment] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [isSubmittingComment, setIsSubmittingComment] = useState(false);

  const handleSaveEdit = async () => {
    setIsSaving(true);
    try {
      await updateDocApi(
        task.ref,
        {
          title: editedTitle,
          content: editedContent,
        },
        prefix,
      );
      task.title = editedTitle;
      task.content = editedContent;
      setIsEditing(false);
      onUpdate();
    } catch (error) {
      console.error("Error saving task:", error);
    }
    setIsSaving(false);
  };

  const handleSubmitComment = async (e) => {
    e.stopPropagation();
    if (!newComment.trim()) return;

    setIsSubmittingComment(true);
    try {
      const comment = {
        id: Date.now().toString(),
        user_id: userData.id,
        content: newComment,
        timestamp: getFlutterTime(),
      };

      const updatedComments = [...comments, comment];

      await updateDocApi(
        task.ref,
        {
          comments: updatedComments,
          seen_by: [userData.id], // Reset seen_by to only the commenting user
        },
        prefix,
      );

      setComments(updatedComments);
      setNewComment("");
      onUpdate();
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
    setIsSubmittingComment(false);
  };

  const handleCancelEdit = () => {
    setEditedTitle(task.title);
    setEditedContent(task.content);
    setIsEditing(false);
  };

  return (
    <div
      className={`
        ${task.done ? "border-green-200 border-l-2 bg-gray-100" : "bg-white "}
        flex flex-col gap-1 border-1 rounded-lg overflow-y-auto h-full relative`}
    >
      {/* Floating back button */}
      <div
        className="absolute top-3 left-3 cursor-pointer hover:bg-gray-100 p-2 rounded-full transition-all shadow-md z-10"
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      >
        <Icon1 icon_name="left" size="18px" fill="#6b7280" />
      </div>

      {/* Floating modify button */}
      <div
        className="absolute top-3 right-14 cursor-pointer hover:bg-blue-50 p-2 rounded-full transition-all shadow-md z-10"
        onClick={(e) => {
          e.stopPropagation();
          setIsEditing(true);
        }}
      >
        <Icon1 icon_name="modify" size="18px" fill="#3b82f6" />
      </div>

      {/* Floating delete button */}
      <div
        className="absolute top-3 right-3 cursor-pointer hover:bg-red-100 p-2 rounded-full transition-all shadow-md z-10"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
      >
        <Icon1 icon_name="delete" size="18px" fill="#ef4444" />
      </div>

      <div className="pt-14 px-6 pb-4 flex flex-col gap-3">
        {/* Title and Content */}
        {isEditing ? (
          <div className="flex flex-col gap-2">
            <TextField2T
              value={editedTitle}
              onChange={(e) => setEditedTitle(e.target.value)}
              label="Titre"
              placeholder="Titre de la tâche"
            />
            <MLTFGPT3
              value={editedContent}
              onChange={(e) => setEditedContent(e.target.value)}
              label="Description"
              placeholder="Description de la tâche"
            />
            <div className="flex flex-row gap-2 justify-end">
              <SecondaryButton onClick={handleCancelEdit}>
                Annuler
              </SecondaryButton>
              <PrimaryButton onClick={handleSaveEdit} disabled={isSaving}>
                Sauvegarder {isSaving && <SmallSpinner />}
              </PrimaryButton>
            </div>
          </div>
        ) : (
          <div>
            <div className="text-lg font-semibold text-gray-900 mb-2">
              {task.title}
            </div>
            <div className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">
              {task.content}
            </div>
          </div>
        )}

        <div className="text-h5 text-gray-300 flex flex-row justify-between mt-2">
          <div> Créée le {dateTextFromFlutterDate(task.creation_date)}</div>
        </div>

        {/* Users assigned */}
        <div className="flex flex-col gap-1 mt-2">
          {task.users_id.map((u, index) => (
            <div
              key={index}
              className="text-h4 text-indigo-500 border-l-2 pl-2 flex flex-row justify-between"
              style={{
                borderColor:
                  intToHexColor(
                    all_users?.find((user) => user.id === u)?.color,
                  ) || "rgba(99, 102, 241, 0.5)",
              }}
            >
              <div className="flex flex-row items-center">
                <img
                  className="w-6 h-6 rounded-full inline mr-2"
                  src={
                    all_users?.find((user) => user.id === u)?.photo ||
                    "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg?20200418092106"
                  }
                />
                {all_users?.find((user) => user.id === u)?.display_name ||
                  "Utilisateur supprimé"}
              </div>
              {loadingUsersDone === u ? (
                <SmallSpinner />
              ) : (
                <CheckBoxGrey
                  idle_border_color_tailwind={"border-indigo-400"}
                  onChange={() => {
                    handleSetUsersDone(u);
                  }}
                  checked={task.users_done_id?.includes(u)}
                />
              )}
            </div>
          ))}
        </div>

        {/* Comments Section */}
        <div className="mt-4 border-t pt-3">
          <div className="text-h4 font-semibold mb-2">Commentaires</div>

          {/* Comments List */}
          <div className="flex flex-col gap-2 mb-3 max-h-c200 overflow-y-auto">
            {comments.length === 0 ? (
              <div className="text-h5 text-gray-400 italic">
                Aucun commentaire
              </div>
            ) : (
              comments.map((comment) => {
                const commentUser = all_users?.find(
                  (u) => u.id === comment.user_id,
                );
                return (
                  <div
                    key={comment.id}
                    className="flex flex-row gap-2 p-2 bg-gray-50 rounded-lg"
                  >
                    <img
                      className="w-8 h-8 rounded-full"
                      src={
                        commentUser?.photo ||
                        "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg?20200418092106"
                      }
                    />
                    <div className="flex flex-col flex-1">
                      <div className="flex flex-row items-baseline gap-2">
                        <span className="text-h4 font-semibold">
                          {commentUser?.display_name || "Utilisateur supprimé"}
                        </span>
                        <span className="text-h6 text-gray-400">
                          {dateTextFromFlutterDate(comment.timestamp)}
                        </span>
                      </div>
                      <div className="text-h4 text-gray-700">
                        {comment.content}
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {/* New Comment Input */}
          <div className="flex flex-col gap-2">
            <textarea
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              placeholder="Ajouter un commentaire..."
              className="w-full p-2 border border-gray-300 rounded-lg text-h4 resize-none"
              rows={2}
            />
            <div className="flex flex-row justify-end">
              <PrimaryButton
                onClick={handleSubmitComment}
                disabled={!newComment.trim() || isSubmittingComment}
              >
                Envoyer {isSubmittingComment && <SmallSpinner />}
              </PrimaryButton>
            </div>
          </div>
        </div>

        {/* Folder Button (if applicable) */}
        {task.folder_ref && (
          <div className="flex flex-row justify-center gap-2 mt-4 pt-3 border-t">
            <SecondaryButton
              onClick={(e) => {
                e.stopPropagation();
                onGoToFolder();
              }}
              className={"w-fit"}
            >
              Aller au dossier
            </SecondaryButton>
          </div>
        )}
      </div>
    </div>
  );
};

export function dateTextFromFlutterDate(flutter_date) {
  // if today return "Aujourd'hui at HH:MM"
  const date = new Date(flutter_date.seconds * 1000);
  const now = new Date();
  if (
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear()
  ) {
    return (
      "Aujourd'hui à " +
      date.getHours().toString().padStart(2, "0") +
      ":" +
      date.getMinutes().toString().padStart(2, "0")
    );
  } else {
    return (
      date.getDate().toString().padStart(2, "0") +
      "/" +
      (date.getMonth() + 1).toString().padStart(2, "0")
    );
  }
}
